import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import api from '../../../helpers/api';
import {getTranslate} from 'react-localize-redux';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifySuccess, notifyError} from '../../../common/redux/notificationReducer';
import {forgotPasswordRules} from '../rules';
import {CustomControl, CustomError, CustomForm} from '../../../common/components';
import forgotPassword from '../locales/forgotPassword.json';

class ForgotPasswordForm extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage} = props;
		loadLanguage(forgotPassword);

		this.state = {
			isLoading: false,
			redirectTo: false,
			forgotPasswordForm: {
				email: ''
			}
		}
	}

	handleSubmit = async (values) => {
		const {notifySuccess, notifyError} = this.props;
		try {
			const response = await api.post('/auth/forgot-password', values);
			notifySuccess(response.message);

			this.setState({ ...this.state, redirectTo: true});
		} catch (error) {
			notifyError(error.message);
		}
	};

	render() {
		const {translate} = this.props;
		const {forgotPasswordForm, redirectTo, isLoading} = this.state;

		if (redirectTo) {
			return <Redirect to='/auth/login' />;
		}

		const loading = (
			<div className="overlay">
				<i className="fa fa-refresh fa-spin"/>
			</div>
		);

		const content = (
			<div className="login-box-body box">
				<p className="login-box-msg">{translate('forgot_password_page_title')}</p>

				<CustomForm model="forgotPasswordForm"
				            initialState={forgotPasswordForm}
				            validators={forgotPasswordRules.validators}
				            onSubmit={this.handleSubmit}
				>
					<div className="form-group has-feedback">
						<CustomControl type="email" model="email" placeholder={translate('forgot_password_email_placeholder')}/>
						<CustomError model="email" messages={forgotPasswordRules.messages} translate={translate}/>
					</div>

					<div className="row">
						<div className="col-xs-12 text-center">
							{
								isLoading ?	loading : (
									<button type="submit" className="btn btn-primary btn-inverse">
										{translate('forgot_password_submit_text')}
									</button>
								)
							}
						</div>
					</div>
				</CustomForm>

				<div className="social-auth-links text-center">
					<Link to="/auth/login">
						{translate('forgot_password_login_title')}
					</Link>
				</div>
			</div>
		);

		return translate('forgot_password_page_title') ? content : <div className="login-box-body box">{ loading }</div>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale)
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifySuccess,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm);